/** @format */

import React from 'react'

class Team extends React.Component {
    render() {
        return (
            <>
                <nav
                    className='navbar navbar-expand-lg bg-dark navbar-light d-none d-lg-block'
                    id='templatemo_nav_top'>
                    <div className='container text-light'>
                        <div className='w-100 d-flex justify-content-between'>
                            <div>
                                <i className='fa fa-envelope mx-2'></i>
                                <a
                                    className='navbar-sm-brand text-light text-decoration-none'
                                    href='mailto:sabz@gmail.com'>
                                    director@sabzonline.in
                                </a>
                                <i className='fa fa-phone mx-2'></i>
                                <a
                                    className='navbar-sm-brand text-light text-decoration-none'
                                    href='tel:+91 7382200558'>
                                    +91 7382200558
                                </a>
                            </div>
                            <div>
                                <a className='text-light' href='/' target='_blank'>
                                    <i className='fab fa-facebook-f fa-sm fa-fw me-2'></i>
                                </a>
                                <a className='text-light' href='/' target='_blank'>
                                    <i className='fab fa-instagram fa-sm fa-fw me-2'></i>
                                </a>
                                <a className='text-light' href='/' target='_blank'>
                                    <i className='fab fa-twitter fa-sm fa-fw me-2'></i>
                                </a>
                                <a className='text-light' href='/' target='_blank'>
                                    <i className='fab fa-linkedin fa-sm fa-fw'></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </nav>
                <nav className='navbar navbar-expand-lg navbar-light shadow'>
                    <div className='container d-flex justify-content-between align-items-center'>
                        <a
                            className='navbar-brand text-success logo h1 align-self-center'
                            href='index.html'>
                            SabZ
                        </a>

                        <button
                            className='navbar-toggler border-0'
                            type='button'
                            data-bs-toggle='collapse'
                            data-bs-target='#templatemo_main_nav'
                            aria-controls='navbarSupportedContent'
                            aria-expanded='false'
                            aria-label='Toggle navigation'>
                            <span className='navbar-toggler-icon'></span>
                        </button>

                        <div
                            className='align-self-center collapse navbar-collapse flex-fill  d-lg-flex justify-content-lg-between'
                            id='templatemo_main_nav'>
                            <div className='flex-fill'>
                                <ul className='nav navbar-nav d-flex justify-content-between mx-lg-auto'>
                                    <li className='nav-item'>
                                        <a className='nav-link' href='index.html'>
                                            Home
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a className='nav-link' href='about.html'>
                                            About
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a className='nav-link dropdown' href='shop_static.html'>
                                            Shop
                                        </a>
                                        {/* <!-- <div className = "dropdown-content">
                                <ul>
                                    <li> <a href="shop_farmer.html">Farmer</a></li>
                                    <li> <a href="shop_dealer.html">Business</a></li>
                                    <li> <a href="shop_resident.html">Residents</a></li>
                                </ul>
                            </div> --> */}
                                    </li>
                                    <li className='nav-item'>
                                        <a className='nav-link' href='#contact'>
                                            Team
                                        </a>
                                    </li>

                                    {/* <!-- <li className="nav-item">
                            <a className="nav-link" href="#">Team</a>
                        </li> -->
                        <!-- <li className="nav-item">
                            <a className="nav-link" href="#">Register</a>
                        </li> --> */}
                                </ul>
                            </div>
                            <div className='navbar align-self-center d-flex'>
                                <div className='d-lg-none flex-sm-fill mt-3 mb-4 col-7 col-sm-auto pr-3'>
                                    <div className='input-group'>
                                        <input
                                            type='text'
                                            className='form-control'
                                            id='inputMobileSearch'
                                            placeholder='Search ...'
                                        />
                                        <div className='input-group-text'>
                                            <i className='fa fa-fw fa-search'></i>
                                        </div>
                                    </div>
                                </div>
                                <a
                                    className='nav-icon d-none d-lg-inline'
                                    href='/'
                                    data-bs-toggle='modal'
                                    data-bs-target='#templatemo_search'>
                                    <i className='fa fa-fw fa-search text-dark mr-2'></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </nav>

                <section className='container py-1'>
                    <div className='row text-center pt-2'>
                        <div className='col-lg-10 m-auto'>
                            {/* <!-- <style>
                    .download-app-text {
                        text-decoration: solid;

                    }
                </style> -->
                <!-- <h1 className="h1 download-app-text  "> <b>Click to Download our app and Shop Now!!!</b></h1> --> */}
                        </div>
                    </div>

                    <div className='row'>
                        {/* <style>
                .login-cards {
                    text-indent: initial;
                    background: rgba(100, 223, 116, 0.726);
                    box-shadow: 0 8px 32px 0 rgba(245, 245, 248, 0.37);
                    backdrop-filter: blur(12.0px);
                    -webkit-backdrop-filter: blur(12.0px);
                    border-radius: 20px;
                    border: 2px solid rgba(239, 243, 239, 0.18);
                    text-align: center;
                    padding: 10px;
                    margin-left: 200px;
                }

                .login-cards h1 {
                    padding: 10px;
                }

                .btn-login {
                    background-color: green;
                    color: white;
                }

                .btn-login:hover {
                    background-color: rgb(224, 153, 153);
                    color: green;
                }

                @media (max-width: 800px) {
                    .login-cards {
                        margin-left: 0px;
                        margin-right: 0px;
                        width: 99%;
                        justify-content: center;
                    }
                }
            </style> */}

                        <div className='col-9 col-md-9 p-3 mt-3'>
                            <div className='login-cards'>
                                <form>
                                    <div className='container py-1'>
                                        <div className='row py-2'>
                                            <form
                                                className='col-md-9 m-auto'
                                                method='post'>
                                                {/* <style>
                                        .download-app-text {
                                            font-family: 'Roboto', sans-serif;
                                            font-size: 22px !important;
                                            color:crimson;
                                        }
                                    </style> */}
                                                <h6 className='  download-app-text '>
                                                    To place orders <b>Download</b> our mobile app
                                                    and<b> shop</b> Now!!!
                                                </h6>
                                                <div className='row'>
                                                    <div className='col text-middle mt-1'>
                                                        <button
                                                            type='submit'
                                                            className='btn btn-success btn-lg px-3'>
                                                            Click to download
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* <!-- To see products available at us -->
            <!-- <div className="col-9 col-md-9 p-3 mt-3">
                <div className="login-cards">
                    <form>
                        <div className="container py-1">
                            <div className="row py-2">
                                <form className="col-md-9 m-auto" method="post" role="form">
                                    <style>
                                        .see-products-text {
                                            font-family: 'Roboto', sans-serif;
                                            font-size: 22px !important;
                                            color:rgb(85, 85, 238);
                                        }
                                    </style>
                                    <h6 className="  see-products-text "> click below to see list of products available at us </h6>
                                    <div className="row">
                                        <div className="col text-middle mt-1">
                                            <button type="submit" className="btn btn-success btn-lg px-3"> See Products available here</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </form>
                </div>
            </div> -->
<!-- To see products available at us --> */}
                    </div>
                </section>

                <footer className='bg-dark' id='tempaltemo_footer'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-5 pt-5 '>
                                <h1 className='sabz-footer'>SabZ</h1>
                                <ul className='list-unstyled text-light footer-link-list'>
                                    <li>
                                        <i className='fas fa-map-marker-alt fa-fw'></i>
                                        <a
                                            className='text-decoration-none'
                                            href='https://www.google.com/maps/place/Sripuram,+B+N+Reddy+Nagar,+Hyderabad,+Telangana/@17.2964112,78.5463355,11.96z/data=!4m5!3m4!1s0x3bcba2224a523487:0x9a411023e840de27!8m2!3d17.3129503!4d78.5580477'>
                                            Plot No. 351, Teachers colony, Saroor Nagar, Hyderabad,
                                            Rangareddy, Telangana, India, Hyderabad, TG, 500035,
                                            India{' '}
                                        </a>
                                    </li>
                                    <li>
                                        <i className='fa fa-phone fa-fw'></i>
                                        <a
                                            className='text-decoration-none'
                                            href='tel:+91 7382200558 '>
                                            +91 7382200558{' '}
                                        </a>
                                    </li>
                                    <li>
                                        <i className='fa fa-envelope fa-fw'></i>
                                        <a
                                            className='text-decoration-none'
                                            href='mailto:SabZ@gmail.com'>
                                            {' '}
                                            director@sabzonline.in{' '}
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className='col-md-2 pt-5'>
                                <h3 className='h3 text-light '>More about us </h3>
                                <ul className='list-unstyled text-light footer-link-list'>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            More search{' '}
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Blogs
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Testimonials{' '}
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Events
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Shop Locations
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className='col-md-3 pt-5'>
                                <h3 className='h3 text-light '>Connect with us </h3>
                                <ul className='list-unstyled text-light footer-link-list'>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Twitter{' '}
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Facebook
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Instagram
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Linkedin
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className='col-md-2 pt-5'>
                                <ul className='list-unstyled text-light footer-link-list'>
                                    <li>
                                        <a
                                            className='  text-light text-decoration-none'
                                            href='privacy_policy.html'>
                                            Privacy Policy
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className='  text-light text-decoration-none'
                                            href='refund_policy.html'>
                                            Refund policy
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className=' text-light text-decoration-none'
                                            href='terms_conditions.html'>
                                            Terms and conditions
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className='row text-light mb-4'>
                            <div className='col-12 mb-3'>
                                <div className='w-100 my-3 '></div>
                            </div>
                            <div className='col-auto me-auto'>
                                <ul className='list-inline  text-left footer-icons'>
                                    <li className='list-inline-item border  rounded-circle text-center'>
                                        <a
                                            className='text-light text-decoration-none'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            href='http://facebook.com/'>
                                            <i className='fab fa-facebook-f fa-lg fa-fw'></i>
                                        </a>
                                    </li>
                                    <li className='list-inline-item border  rounded-circle  text-center'>
                                        <a
                                            className='text-light text-decoration-none'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            href='https://www.instagram.com/'>
                                            <i className='fab fa-instagram fa-lg fa-fw'></i>
                                        </a>
                                    </li>
                                    <li className='list-inline-item border  rounded-circle text-center'>
                                        <a
                                            className='text-light text-decoration-none'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            href='https://twitter.com/'>
                                            <i className='fab fa-twitter fa-lg fa-fw'></i>
                                        </a>
                                    </li>
                                    <li className='list-inline-item border  rounded-circle text-center'>
                                        <a
                                            className='text-light text-decoration-none'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            href='https://www.linkedin.com/'>
                                            <i className='fab fa-linkedin fa-lg fa-fw'></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        )
    }
}
export default Team
